// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../../../../../node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../../../../node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `/**** Manager page ****/

/** Summary box at top of page 
 * Includes those two rows of meta information and the chart on the right **/
#manager .summary {
  background-color: #f5f5f5;
  padding-left: 2rem;
  padding-right: 2rem;
}

/* The people/assignments headers in the summary
 * Also the pie chart header
 */
#manager .summary .summaryHeader {
  font-weight: bold;
  font-size: 16px;
  margin-top: 2rem;
  margin-bottom: 0.5rem;
}

/* The boxes underneath the people and assignment sections in the summary */
#manager .summary .summaryRow {
  display: flex;
  justify-content: flex-begin;
}
/* The formatting for each summary box */
#manager .summary .summaryRow .summaryBox {
  /*
    padding-left: 2.5rem;
    padding-right: 2.5rem;
    */
  width: 16rem;
  padding-top: 1.5rem;
  padding-bottom: 1rem;
  background-color: white;
  border: 1px solid black;
  display: flex;
  flex-direction: column;
  align-items: center;
}
#manager .summary .summaryRow .summaryBox .title {
  font-size: 12px;
  color: black;
  text-align: center;
}
#manager .summary .summaryRow .summaryBox .amount {
  font-weight: bold;
  font-size: 26px;
  text-align: center;
}

/* Pie chart */
#manager .summary .summaryPieChart .summaryPieChartContainer .chart-container {
  margin-top: 1rem;
  margin-left: 0;
}

/* summary pie chart legend */
#manager .summary .summaryPieChart .chartBody {
  /* Make the pie chart and chart legend have equal height */
  display: flex;
}
#manager .summary .summaryPieChart .chartBody .chartLegend {
  display: flex;
  flex-direction: column;
  align-items: flex-start;
  justify-content: flex-end;
  padding-left: 6rem;
  padding-bottom: 1rem;
}
#manager .summary .summaryPieChart .chartBody .chartLegend .amount {
  font-weight: bold;
  font-size: 24px;
  display: block;
  text-align: center;
}

#manager .summary .summaryPieChart .chartBody .chartLegend .title {
  font-weight: bold;
  font-size: 12px;
  display: block;
  margin-top: -1rem;
  text-align: center;
  padding: 5px 0 5px 0;
}

/* Make the summary pie chart work at different resolutions */
@media (min-width: 1024px) and (max-width: 1299px) {
  /* Summary boxes */
  div#manager .summary .summaryRow .summaryBox {
    /* width: 11rem; */
    width: 18%;
    justify-content: flex-end;
  }
  div#manager .summary .summaryRow .summaryBox .title {
    /* This makes word wrapping work in ie11 */
    width: 100%;
  }
  div#manager .summary .summaryRows {
    width: 60%;
  }

  /* Summary pie chart */
  div#manager .summary .summaryHeader {
    text-align: center;
  }
  div#manager
    .summary
    .summaryPieChart
    .summaryPieChartContainer
    .chart-container {
    margin-left: 1rem;
  }
  div#manager .summary .summaryPieChart .chartBody .chartLegend {
    padding-left: 3rem;
  }

  div#manager .resultPieChartContainer .resultPieChart {
    margin-left: 0;
  }

  /* Team summary */
  div#manager .searchResult.teamSummary .assignmentTotals {
    padding-left: 2.5rem;
  }
}

/*** EMPTY PIE CHART STUFF ***/
/* Every empty pie chart is just a big white circle */
#manager .emptyPieChart {
  background-color: white;
  display: inline-block;
  border-radius: 50%;
}
/* Minion empty pie charts */
#manager .emptyPieChartContainer {
  display: flex;
  justify-content: center;
}
#manager .emptyPieChartContainer .emptyPieChart.minion {
  margin-left: 7rem;
  /* Make sure this thing never gets bigger or smaller */
  min-width: 177px;
  min-height: 177px;
  max-width: 177px;
  max-height: 177px;
}

@media (min-width: 992px) and (max-width: 1023px) {
  #manager div.emptyPieChartContainer .emptyPieChart.minion {
    margin-left: 0rem;
  }
}
@media (max-width: 1299px) and (min-width: 1024px) {
  #manager div.emptyPieChartContainer .emptyPieChart.minion {
    margin-left: 3rem;
  }
}

/* top of page summary */
#manager .emptySummaryPieChartContainer {
  margin-top: 1rem;
  margin-left: 0;
}

/* The team lead under the search result. Also top of page summary */
#manager .emptyPieChart.summary {
  /* Make sure this thing never gets bigger or smaller */
  min-width: 195px;
  min-height: 195px;
  max-width: 195px;
  max-height: 195px;
}

/** The little summary expander **/
#manager .summaryExpander {
  display: flex;
  justify-content: center;
  background-color: #f5f5f5;
  padding-top: 2rem;
  padding-bottom: 1.5rem;
}

/** Search bar and filters **/
#manager .filterAndSearchBar {
  margin-top: 3rem;
  border-bottom: 1px solid #e5e5e5;
  padding-bottom: 1rem;
  display: flex;
  align-items: baseline;
}

/* Team filters to the left on search bar */
#manager .filterAndSearchBar .filterBar {
  padding-left: 0;
}

/* The direct team filter on search bar */
#manager .directTeam {
  /* Make it so we can have a flyout under the direct team link */
  position: relative;
  font-size: 14px;
}
#manager .filterAndSearchBar .filterBar .selected a {
  font-weight: bold;
  color: black;
  text-decoration: none;
  border-bottom: 2px solid black;
}
/* This is the little down error next to the direct team action item */
#manager .filterAndSearchBar .filterBar .directTeam img {
  padding-left: 1px;
  margin-bottom: 3px;
}

/* The alternate team filter on search bar */
#manager .filterAndSearchBar .filterBar .alternateTeam {
  color: #aeaeae;
  font-size: 14px;
}

/* The direct team flyout */
#manager .directTeamFlyout {
  position: absolute;
  left: 10rem;
  top: 2rem;
  background-color: white;
  -webkit-box-shadow: 2px 3px 2px 0px rgba(0, 0, 0, 0.23);
  -moz-box-shadow: 2px 3px 2px 0px rgba(0, 0, 0, 0.23);
  box-shadow: 2px 3px 2px 0px rgba(0, 0, 0, 0.23);
  padding-left: 0;
  z-index: 1;
}
#manager .directTeamFlyout li {
  list-style-type: none;
  width: 22rem;
  padding-top: 0.4rem;
  padding-bottom: 0.4rem;
  padding-left: 1rem;
  border-bottom: 1px solid #d5d5d5;
  border-left: 1px solid #d5d5d5;
  cursor: pointer;
  /* Makes the text and checkmark on either side of the row */
  display: flex;
  justify-content: space-between;
}
/* Enhance the shadow effects in the flyout */
#manager .directTeamFlyout li:last-child {
  border-bottom: initial;
}
#manager .directTeamFlyout li:first-child {
  border-top: 1px solid rgba(0, 0, 0, 0.1);
}
/* The check mark on the right of selected items in the direct team flyout */
#manager .directTeamFlyout li .checkMark {
  padding-right: 1.5rem;
}

/* The pipe character between the team filters on the search bar */
#manager .filterAndSearchBar .filterBar .filter + .filter:before {
  content: '|';
  color: black;
  margin-left: 1rem;
  margin-right: 1rem;
}

/* The input box on the search bar */
#manager .filterAndSearchBar .searchBar {
  display: flex;
  padding-right: 0;
  position: relative;
}
#manager .filterAndSearchBar .searchBar input {
  font-size: 14px;
  border: 1px solid #7f7f7f;
  padding-left: 1.5rem;
  padding-top: 0.5rem;
  padding-bottom: 0.5rem;
  margin-left: 1rem;
  flex-grow: 1;
}

/* The searchbar flyout */
#manager .searchBarFlyout {
  position: absolute;
  left: 1.5rem;
  top: 4rem;
  background-color: white;
  -webkit-box-shadow: 2px 3px 2px 0px rgba(0, 0, 0, 0.23);
  -moz-box-shadow: 2px 3px 2px 0px rgba(0, 0, 0, 0.23);
  box-shadow: 2px 3px 2px 0px rgba(0, 0, 0, 0.23);
  padding-left: 0;
}
#manager .searchBarFlyout li {
  list-style-type: none;
  width: 13rem;
  padding-top: 0.5rem;
  padding-bottom: 0.5rem;
  padding-left: 0.5rem;
  border-bottom: 1px solid #d5d5d5;
  border-left: 1px solid #d5d5d5;
  display: flex;
  cursor: pointer;
}
/* Make the row not interfere with the shadow */
#manager .searchBarFlyout li:last-child {
  border-bottom: initial;
}
/* Give the first row an extra shadow effect */
#manager .searchBarFlyout li:first-child {
  border-top: 1px solid rgba(0, 0, 0, 0.1);
}
#manager .searchBarFlyout li img {
  margin-right: 0.8rem;
}
/* The icon in left of each row of the search bar flyout */
#manager .searchBarFlyout li .icon {
  width: 3rem;
  display: flex;
  justify-content: center;
}
/* The selection mark on the right of each flyout */
#manager .searchBarFlyout li .checkMark {
  position: absolute;
  right: 0;
}

/* color the default text in the search bar box */
#manager .filterAndSearchBar .searchBar input::-webkit-input-placeholder {
  /* WebKit, Blink, Edge */
  color: #7f7f7f;
  font-weight: bold;
}
#manager .filterAndSearchBar .searchBar input:-moz-placeholder {
  /* Mozilla Firefox 4 to 18 */
  color: #7f7f7f;
  opacity: 1;
  font-weight: bold;
}
#manager .filterAndSearchBar .searchBar input::-moz-placeholder {
  /* Mozilla Firefox 19+ */
  color: #7f7f7f;
  opacity: 1;
  font-weight: bold;
}
#manager .filterAndSearchBar .searchBar input:-ms-input-placeholder {
  /* Internet Explorer 10-11 */
  color: #7f7f7f;
  font-weight: bold;
}

/** Breadcrumb **/
#manager .breadcrumb {
  margin-bottom: 2rem;
}
/* spacing around separator is slightly different on
 * manager dashboard */
#manager .breadcrumb .active span {
  padding-left: 6px;
}
#manager .breadcrumb .active {
  padding-left: 0;
}

/** Search results title **/
#manager .resultsHeader {
  margin: 4rem 0rem 2rem 0rem;
}

#manager .resultsHeader a {
  float: right;
  font-size: 12px;
}

#manager .resultsHeader h3 {
  font-size: 24px;
  font-weight: bold;
  margin: 0px;
}

/** Individual search results **/
#manager .searchResult {
  margin-top: 1rem;
}
/* Search result header */
#manager .searchResult .header {
  background-color: #e5e5e5;
  overflow: hidden;
  /* height: 12rem; */
  height: 4rem;
}
#manager .searchResult .memberNameAndProfileTable {
  width: 30%;
}
#manager .searchResult .header .name {
  display: inline-block;
  font-size: 20px;
  padding-left: 0.8rem;
}
#manager .searchResult .managerExpander {
  display: inline-block;
}

/* The little sheeple icon */
#manager .searchResult .sheepleIcon {
  vertical-align: baseline;
  margin-bottom: -1px;
  padding-left: 0.2rem;
}

/* The list of folks under the manager if search result is a manager */
#manager .searchResult .numberOfReports a,
#manager .searchResult .numberOfReports {
  font-size: 10px;
}

#manager .searchResult .numberOfReports {
  top: -1rem;
}

/* The assignment / view transcript actions on the header of each search result */
#manager .searchResult .actionItems {
  height: 4rem; /* matches height of #manager .searchResult .header. be sure to change both if you change this */
  display: flex;
  align-items: flex-end;
  padding-bottom: 0.8rem;
  padding-right: 2rem;
}

#manager .searchResult .actionItems a {
  font-size: 12px;
}

/* The pipe character between the action items */
#manager .searchResult .actionItem + .actionItem:before {
  content: '|';
  color: black;
  margin-left: 1rem;
  margin-right: 1rem;
}

/* Search result profile info */
#manager .searchResult .profileInfo {
  background-color: #e5e5e5;
  margin-left: 0;
  margin-right: 0;
  padding-left: 0.9rem;
  padding-bottom: 1.2rem;
}

#manager .searchResult .closeProfileInfo {
  margin-top: 0.2rem;
}
#manager .searchResult .closeProfileInfo a {
  font-size: 12px;
}
#manager .searchResult .profileInfo .italic {
  font-style: italic;
}
#manager .searchResult .profileInfo .alignRight {
  text-align: right;
}

/* Search result body */
#manager .searchResult .body {
  background-color: #f5f5f5;
  overflow: hidden;
  padding-top: 3rem;
  padding-bottom: 1.5rem;
}

/* Indent the pie chart for the search results */
#manager .resultPieChartContainer .resultPieChart {
  margin-left: 3rem;
}
/* Make the pie chart and legend have the same height */
#manager .searchResult .resultPieChartContainer {
  display: flex;
}

/* Search result pie chart legend */
#manager .searchResult .legend {
  display: flex;
  justify-content: flex-end;
  flex-direction: column;
  align-items: flex-end;
  padding-bottom: 3rem;
  padding-left: 0;
  width: 11rem;
}
#manager .searchResult .legendItem {
  border: 1px solid black;
  padding-left: 1rem;
  padding-right: 1rem;
  padding-bottom: 1rem;
  padding-top: 0;
  display: flex;
  align-items: center;
  flex-direction: column;
  width: 10rem;
  background-color: #f9f9f9;
}
#manager .searchResult .legendItem + .legendItem {
  margin-top: 1.5rem;
}
#manager .searchResult .legendItem .amount {
  font-size: 24px;
  font-weight: bold;
  margin-bottom: -0.7rem;
}

#manager .searchResult .legendItem .title {
  font-weight: bold;
}

/* Search result assignment totals table */
#manager .searchResult .assignmentTotals {
  /* On the search results, not the team summary,
     * the table is slightly indented */
  padding-left: 5rem;
}
#manager .searchResult .assignmentTotals table {
  width: 100%;
}
#manager .searchResult .assignmentTotals th {
  font-weight: bold;
  text-align: center;
}
#manager .searchResult .assignmentTotals tbody tr {
  border-bottom: 1px solid #c3c2c2;
}
#manager .searchResult .assignmentTotals tbody td {
  padding-top: 0.5rem;
  padding-bottom: 0.5rem;
}

#manager .searchResult .assignmentTotals tbody td a,
#manager .searchResult .assignmentTotals tbody td p {
  display: inline;
  font-size: 12px;
}

/* The data in the table (not the left most column) should be centered in the middle */
#manager .searchResult .assignmentTotals tbody td + td {
  text-align: center;
}
#manager .searchResult .assignmentTotals tfoot {
  font-weight: bold;
}
#manager .searchResult .assignmentTotals tfoot td {
  padding-top: 0.5rem;
}
/* The footer boxes except for the leftmost column should be centered */
#manager .searchResult .assignmentTotals tfoot td + td {
  text-align: center;
}

#manager .searchResult .assignmentTotals .disable-href {
  pointer-events: none !important;
}

#manager .searchResult .assignmentTotals .enable-href {
  pointer-events: auto !important;
}

/** Team summary overrides
 * The team summary component is just like the searchResult component except with 
 * some overrides for the background color and pie chart */
/* Background, title and team overrides */
#manager .searchResult.teamSummary .header {
  background-color: initial;
  height: initial;
}
#manager .searchResult.teamSummary .header .name {
  font-size: 24px;
  font-weight: bold;
}
#manager .searchResult.teamSummary .body {
  background-color: initial;
  padding-bottom: 3rem;
  border-bottom: 3px solid #009ce6;
}
/* Legend override */
#manager .searchResult.teamSummary .legendItem {
  width: 11rem;
  background-color: initial;
}
#manager .searchResult.teamSummary .legendItem .amount {
  font-size: 30px;
}
#manager .searchResult.teamSummary .legendItem .title {
  font-size: 14px;
}
/* Pie chart override. Don't indent pie cahrt on manager summary */
#manager .teamSummary .resultPieChartContainer .resultPieChart {
  margin-left: initial;
}

/* Table override */
#manager .searchResult.teamSummary .assignmentTotals {
  padding-left: initial;
}

.managerCourseList .md-datepicker-input-container .md-datepicker-input,
.managerCourseList
  .md-datepicker-input-container
  .md-datepicker-triangle-button,
.managerCourseList .md-datepicker-input-container {
  visibility: hidden;
}

.managerCourseList .edit {
  margin-right: 15px;
}

.managerCourseList .spinner {
  margin: 0px 125px;
}

.featureClass,
.featureClass td {
  text-decoration: none !important;
  color: #979797 !important;
}

#manager .searchBar .magnifying-glass svg {
  height: 32px;
  width: 32px;
}

#manager .assignmentsHeader #hierarchyToggle {
  margin-right: 5px;
  vertical-align: text-bottom;
}

#manager .chartLegend .row {
  background-color: white;
  border: solid black 1px;
  padding: 0 1rem 0 1rem;
  min-width: 10rem;
  margin-top: 10px;
}

#manager .overdue {
  color: #f63f3f;
}

#manager .complete .amount {
  color: #009ce6;
}
#manager .chartLegend .incomplete .amount {
  color: #d6d6d6;
}

/* Make the team list work at different resolutions */
@media screen and (max-width: 1200px) {
  .searchResultRow {
    width: 100%;
    background-color: #e5e5e5;
    height: 100%;
  }

  #manager .searchResult .header {
    overflow: visible;
  }

  .barPercentComplete {
    padding-left: 20%;
    padding-top: 0px !important;
  }

  .actionItemLinks {
    float: left !important;
    padding-left: 20%;
  }
}

#manager #overdueModal .overdueAssignmentList {
  max-height: 55rem;
  overflow: auto;
}

#manager #overdueModal .overdueAssignment {
  padding: 20px;
  border-bottom: 1px solid #e5e5e5;
  padding-left: 40px;
}

#manager #overdueModal .title {
  font-size: 16px;
  font-weight: bold;
}

#manager #overdueModal .exportSpinner .spinner {
  margin: 10px 10px 0px 0px;
  float: right;
}

#manager .exportOverdue .spinner {
  height: 20px;
  margin: 0;
  width: 100px;
}

#manager .exportOverdue .title {
  text-decoration: underline;
  border: none;
  background-color: white;
  padding-left: 20%;
}

/*  Career Path Student Summary - Start */

#careerPathStudentSummary .cpStudentTile {
  padding-top: 1.5rem;
  padding-bottom: 1rem;
  background-color: #f5f5f5;
  border: 1px solid #e5e5e5;
  display: flex;
  flex-direction: column;
  align-items: center;
  margin-bottom: 20px;
}

#careerPathStudentSummary .cpStudentHeader {
  border-bottom: 1px solid #e5e5e5;
  width: 90%;
}

#careerPathStudentSummary .cpStudentHeader span {
  padding-bottom: 5px;
  padding-left: 0px;
}

#careerPathStudentSummary .cpStudentDetails {
  padding-top: 20px;
  width: 90%;
}

#careerPathStudentSummary .cpStudentDetails span {
  padding-bottom: 5px;
  padding-left: 0px;
}

#careerPathStudentSummary .resultsHeader a {
  float: right;
  font-size: 12px;
}

.masonry-layout {
  column-count: 3;
  -webkit-column-count: 3;
}

#careerPathStudentSummary .cpDetails {
  width: 100%;
  padding-bottom: 15px !important;
}

#careerPathStudentSummary .filterCPBar {
  margin-left: 0px;
  padding-bottom: 1rem;
  margin-bottom: 2rem;
  margin-right: 0px;
  border-bottom: none;
}

#careerPathStudentSummary .lastItemInCPDeets {
  padding-bottom: 5px;
}

#careerPathStudentSummary .noLeftPadding {
  padding-left: 0px;
}

#careerPathStudentSummary .smallProfileLink {
  font-size: 12px;
  color: #000;
}

#careerPathStudentSummary .flexAlign {
  display: flex;
  flex-flow: row wrap;
  justify-content: flex-start;
  align-content: flex-start;
  align-items: flex-start;
}

/*  Career Path Student Summary - End */
`, "",{"version":3,"sources":["webpack://./apps/lms/src/css/manager/manager.css"],"names":[],"mappings":"AAAA,uBAAuB;;AAEvB;4EAC4E;AAC5E;EACE,yBAAyB;EACzB,kBAAkB;EAClB,mBAAmB;AACrB;;AAEA;;EAEE;AACF;EACE,iBAAiB;EACjB,eAAe;EACf,gBAAgB;EAChB,qBAAqB;AACvB;;AAEA,2EAA2E;AAC3E;EACE,aAAa;EACb,2BAA2B;AAC7B;AACA,wCAAwC;AACxC;EACE;;;KAGG;EACH,YAAY;EACZ,mBAAmB;EACnB,oBAAoB;EACpB,uBAAuB;EACvB,uBAAuB;EACvB,aAAa;EACb,sBAAsB;EACtB,mBAAmB;AACrB;AACA;EACE,eAAe;EACf,YAAY;EACZ,kBAAkB;AACpB;AACA;EACE,iBAAiB;EACjB,eAAe;EACf,kBAAkB;AACpB;;AAEA,cAAc;AACd;EACE,gBAAgB;EAChB,cAAc;AAChB;;AAEA,6BAA6B;AAC7B;EACE,0DAA0D;EAC1D,aAAa;AACf;AACA;EACE,aAAa;EACb,sBAAsB;EACtB,uBAAuB;EACvB,yBAAyB;EACzB,kBAAkB;EAClB,oBAAoB;AACtB;AACA;EACE,iBAAiB;EACjB,eAAe;EACf,cAAc;EACd,kBAAkB;AACpB;;AAEA;EACE,iBAAiB;EACjB,eAAe;EACf,cAAc;EACd,iBAAiB;EACjB,kBAAkB;EAClB,oBAAoB;AACtB;;AAEA,6DAA6D;AAC7D;EACE,kBAAkB;EAClB;IACE,kBAAkB;IAClB,UAAU;IACV,yBAAyB;EAC3B;EACA;IACE,0CAA0C;IAC1C,WAAW;EACb;EACA;IACE,UAAU;EACZ;;EAEA,sBAAsB;EACtB;IACE,kBAAkB;EACpB;EACA;;;;;IAKE,iBAAiB;EACnB;EACA;IACE,kBAAkB;EACpB;;EAEA;IACE,cAAc;EAChB;;EAEA,iBAAiB;EACjB;IACE,oBAAoB;EACtB;AACF;;AAEA,8BAA8B;AAC9B,qDAAqD;AACrD;EACE,uBAAuB;EACvB,qBAAqB;EACrB,kBAAkB;AACpB;AACA,4BAA4B;AAC5B;EACE,aAAa;EACb,uBAAuB;AACzB;AACA;EACE,iBAAiB;EACjB,sDAAsD;EACtD,gBAAgB;EAChB,iBAAiB;EACjB,gBAAgB;EAChB,iBAAiB;AACnB;;AAEA;EACE;IACE,iBAAiB;EACnB;AACF;AACA;EACE;IACE,iBAAiB;EACnB;AACF;;AAEA,wBAAwB;AACxB;EACE,gBAAgB;EAChB,cAAc;AAChB;;AAEA,oEAAoE;AACpE;EACE,sDAAsD;EACtD,gBAAgB;EAChB,iBAAiB;EACjB,gBAAgB;EAChB,iBAAiB;AACnB;;AAEA,kCAAkC;AAClC;EACE,aAAa;EACb,uBAAuB;EACvB,yBAAyB;EACzB,iBAAiB;EACjB,sBAAsB;AACxB;;AAEA,6BAA6B;AAC7B;EACE,gBAAgB;EAChB,gCAAgC;EAChC,oBAAoB;EACpB,aAAa;EACb,qBAAqB;AACvB;;AAEA,2CAA2C;AAC3C;EACE,eAAe;AACjB;;AAEA,yCAAyC;AACzC;EACE,+DAA+D;EAC/D,kBAAkB;EAClB,eAAe;AACjB;AACA;EACE,iBAAiB;EACjB,YAAY;EACZ,qBAAqB;EACrB,8BAA8B;AAChC;AACA,sEAAsE;AACtE;EACE,iBAAiB;EACjB,kBAAkB;AACpB;;AAEA,4CAA4C;AAC5C;EACE,cAAc;EACd,eAAe;AACjB;;AAEA,2BAA2B;AAC3B;EACE,kBAAkB;EAClB,WAAW;EACX,SAAS;EACT,uBAAuB;EACvB,uDAAuD;EACvD,oDAAoD;EACpD,+CAA+C;EAC/C,eAAe;EACf,UAAU;AACZ;AACA;EACE,qBAAqB;EACrB,YAAY;EACZ,mBAAmB;EACnB,sBAAsB;EACtB,kBAAkB;EAClB,gCAAgC;EAChC,8BAA8B;EAC9B,eAAe;EACf,2DAA2D;EAC3D,aAAa;EACb,8BAA8B;AAChC;AACA,6CAA6C;AAC7C;EACE,sBAAsB;AACxB;AACA;EACE,wCAAwC;AAC1C;AACA,4EAA4E;AAC5E;EACE,qBAAqB;AACvB;;AAEA,kEAAkE;AAClE;EACE,YAAY;EACZ,YAAY;EACZ,iBAAiB;EACjB,kBAAkB;AACpB;;AAEA,oCAAoC;AACpC;EACE,aAAa;EACb,gBAAgB;EAChB,kBAAkB;AACpB;AACA;EACE,eAAe;EACf,yBAAyB;EACzB,oBAAoB;EACpB,mBAAmB;EACnB,sBAAsB;EACtB,iBAAiB;EACjB,YAAY;AACd;;AAEA,yBAAyB;AACzB;EACE,kBAAkB;EAClB,YAAY;EACZ,SAAS;EACT,uBAAuB;EACvB,uDAAuD;EACvD,oDAAoD;EACpD,+CAA+C;EAC/C,eAAe;AACjB;AACA;EACE,qBAAqB;EACrB,YAAY;EACZ,mBAAmB;EACnB,sBAAsB;EACtB,oBAAoB;EACpB,gCAAgC;EAChC,8BAA8B;EAC9B,aAAa;EACb,eAAe;AACjB;AACA,+CAA+C;AAC/C;EACE,sBAAsB;AACxB;AACA,8CAA8C;AAC9C;EACE,wCAAwC;AAC1C;AACA;EACE,oBAAoB;AACtB;AACA,0DAA0D;AAC1D;EACE,WAAW;EACX,aAAa;EACb,uBAAuB;AACzB;AACA,mDAAmD;AACnD;EACE,kBAAkB;EAClB,QAAQ;AACV;;AAEA,iDAAiD;AACjD;EACE,wBAAwB;EACxB,cAAc;EACd,iBAAiB;AACnB;AACA;EACE,4BAA4B;EAC5B,cAAc;EACd,UAAU;EACV,iBAAiB;AACnB;AACA;EACE,wBAAwB;EACxB,cAAc;EACd,UAAU;EACV,iBAAiB;AACnB;AACA;EACE,4BAA4B;EAC5B,cAAc;EACd,iBAAiB;AACnB;;AAEA,iBAAiB;AACjB;EACE,mBAAmB;AACrB;AACA;sBACsB;AACtB;EACE,iBAAiB;AACnB;AACA;EACE,eAAe;AACjB;;AAEA,2BAA2B;AAC3B;EACE,2BAA2B;AAC7B;;AAEA;EACE,YAAY;EACZ,eAAe;AACjB;;AAEA;EACE,eAAe;EACf,iBAAiB;EACjB,WAAW;AACb;;AAEA,gCAAgC;AAChC;EACE,gBAAgB;AAClB;AACA,yBAAyB;AACzB;EACE,yBAAyB;EACzB,gBAAgB;EAChB,mBAAmB;EACnB,YAAY;AACd;AACA;EACE,UAAU;AACZ;AACA;EACE,qBAAqB;EACrB,eAAe;EACf,oBAAoB;AACtB;AACA;EACE,qBAAqB;AACvB;;AAEA,4BAA4B;AAC5B;EACE,wBAAwB;EACxB,mBAAmB;EACnB,oBAAoB;AACtB;;AAEA,sEAAsE;AACtE;;EAEE,eAAe;AACjB;;AAEA;EACE,UAAU;AACZ;;AAEA,iFAAiF;AACjF;EACE,YAAY,EAAE,gGAAgG;EAC9G,aAAa;EACb,qBAAqB;EACrB,sBAAsB;EACtB,mBAAmB;AACrB;;AAEA;EACE,eAAe;AACjB;;AAEA,gDAAgD;AAChD;EACE,YAAY;EACZ,YAAY;EACZ,iBAAiB;EACjB,kBAAkB;AACpB;;AAEA,+BAA+B;AAC/B;EACE,yBAAyB;EACzB,cAAc;EACd,eAAe;EACf,oBAAoB;EACpB,sBAAsB;AACxB;;AAEA;EACE,kBAAkB;AACpB;AACA;EACE,eAAe;AACjB;AACA;EACE,kBAAkB;AACpB;AACA;EACE,iBAAiB;AACnB;;AAEA,uBAAuB;AACvB;EACE,yBAAyB;EACzB,gBAAgB;EAChB,iBAAiB;EACjB,sBAAsB;AACxB;;AAEA,gDAAgD;AAChD;EACE,iBAAiB;AACnB;AACA,uDAAuD;AACvD;EACE,aAAa;AACf;;AAEA,mCAAmC;AACnC;EACE,aAAa;EACb,yBAAyB;EACzB,sBAAsB;EACtB,qBAAqB;EACrB,oBAAoB;EACpB,eAAe;EACf,YAAY;AACd;AACA;EACE,uBAAuB;EACvB,kBAAkB;EAClB,mBAAmB;EACnB,oBAAoB;EACpB,cAAc;EACd,aAAa;EACb,mBAAmB;EACnB,sBAAsB;EACtB,YAAY;EACZ,yBAAyB;AAC3B;AACA;EACE,kBAAkB;AACpB;AACA;EACE,eAAe;EACf,iBAAiB;EACjB,sBAAsB;AACxB;;AAEA;EACE,iBAAiB;AACnB;;AAEA,0CAA0C;AAC1C;EACE;uCACqC;EACrC,kBAAkB;AACpB;AACA;EACE,WAAW;AACb;AACA;EACE,iBAAiB;EACjB,kBAAkB;AACpB;AACA;EACE,gCAAgC;AAClC;AACA;EACE,mBAAmB;EACnB,sBAAsB;AACxB;;AAEA;;EAEE,eAAe;EACf,eAAe;AACjB;;AAEA,sFAAsF;AACtF;EACE,kBAAkB;AACpB;AACA;EACE,iBAAiB;AACnB;AACA;EACE,mBAAmB;AACrB;AACA,uEAAuE;AACvE;EACE,kBAAkB;AACpB;;AAEA;EACE,+BAA+B;AACjC;;AAEA;EACE,+BAA+B;AACjC;;AAEA;;0DAE0D;AAC1D,yCAAyC;AACzC;EACE,yBAAyB;EACzB,eAAe;AACjB;AACA;EACE,eAAe;EACf,iBAAiB;AACnB;AACA;EACE,yBAAyB;EACzB,oBAAoB;EACpB,gCAAgC;AAClC;AACA,oBAAoB;AACpB;EACE,YAAY;EACZ,yBAAyB;AAC3B;AACA;EACE,eAAe;AACjB;AACA;EACE,eAAe;AACjB;AACA,kEAAkE;AAClE;EACE,oBAAoB;AACtB;;AAEA,mBAAmB;AACnB;EACE,qBAAqB;AACvB;;AAEA;;;;;EAKE,kBAAkB;AACpB;;AAEA;EACE,kBAAkB;AACpB;;AAEA;EACE,iBAAiB;AACnB;;AAEA;;EAEE,gCAAgC;EAChC,yBAAyB;AAC3B;;AAEA;EACE,YAAY;EACZ,WAAW;AACb;;AAEA;EACE,iBAAiB;EACjB,2BAA2B;AAC7B;;AAEA;EACE,uBAAuB;EACvB,uBAAuB;EACvB,sBAAsB;EACtB,gBAAgB;EAChB,gBAAgB;AAClB;;AAEA;EACE,cAAc;AAChB;;AAEA;EACE,cAAc;AAChB;AACA;EACE,cAAc;AAChB;;AAEA,qDAAqD;AACrD;EACE;IACE,WAAW;IACX,yBAAyB;IACzB,YAAY;EACd;;EAEA;IACE,iBAAiB;EACnB;;EAEA;IACE,iBAAiB;IACjB,2BAA2B;EAC7B;;EAEA;IACE,sBAAsB;IACtB,iBAAiB;EACnB;AACF;;AAEA;EACE,iBAAiB;EACjB,cAAc;AAChB;;AAEA;EACE,aAAa;EACb,gCAAgC;EAChC,kBAAkB;AACpB;;AAEA;EACE,eAAe;EACf,iBAAiB;AACnB;;AAEA;EACE,yBAAyB;EACzB,YAAY;AACd;;AAEA;EACE,YAAY;EACZ,SAAS;EACT,YAAY;AACd;;AAEA;EACE,0BAA0B;EAC1B,YAAY;EACZ,uBAAuB;EACvB,iBAAiB;AACnB;;AAEA,yCAAyC;;AAEzC;EACE,mBAAmB;EACnB,oBAAoB;EACpB,yBAAyB;EACzB,yBAAyB;EACzB,aAAa;EACb,sBAAsB;EACtB,mBAAmB;EACnB,mBAAmB;AACrB;;AAEA;EACE,gCAAgC;EAChC,UAAU;AACZ;;AAEA;EACE,mBAAmB;EACnB,iBAAiB;AACnB;;AAEA;EACE,iBAAiB;EACjB,UAAU;AACZ;;AAEA;EACE,mBAAmB;EACnB,iBAAiB;AACnB;;AAEA;EACE,YAAY;EACZ,eAAe;AACjB;;AAEA;EACE,eAAe;EACf,uBAAuB;AACzB;;AAEA;EACE,WAAW;EACX,+BAA+B;AACjC;;AAEA;EACE,gBAAgB;EAChB,oBAAoB;EACpB,mBAAmB;EACnB,iBAAiB;EACjB,mBAAmB;AACrB;;AAEA;EACE,mBAAmB;AACrB;;AAEA;EACE,iBAAiB;AACnB;;AAEA;EACE,eAAe;EACf,WAAW;AACb;;AAEA;EACE,aAAa;EACb,mBAAmB;EACnB,2BAA2B;EAC3B,yBAAyB;EACzB,uBAAuB;AACzB;;AAEA,uCAAuC","sourcesContent":["/**** Manager page ****/\n\n/** Summary box at top of page \n * Includes those two rows of meta information and the chart on the right **/\n#manager .summary {\n  background-color: #f5f5f5;\n  padding-left: 2rem;\n  padding-right: 2rem;\n}\n\n/* The people/assignments headers in the summary\n * Also the pie chart header\n */\n#manager .summary .summaryHeader {\n  font-weight: bold;\n  font-size: 16px;\n  margin-top: 2rem;\n  margin-bottom: 0.5rem;\n}\n\n/* The boxes underneath the people and assignment sections in the summary */\n#manager .summary .summaryRow {\n  display: flex;\n  justify-content: flex-begin;\n}\n/* The formatting for each summary box */\n#manager .summary .summaryRow .summaryBox {\n  /*\n    padding-left: 2.5rem;\n    padding-right: 2.5rem;\n    */\n  width: 16rem;\n  padding-top: 1.5rem;\n  padding-bottom: 1rem;\n  background-color: white;\n  border: 1px solid black;\n  display: flex;\n  flex-direction: column;\n  align-items: center;\n}\n#manager .summary .summaryRow .summaryBox .title {\n  font-size: 12px;\n  color: black;\n  text-align: center;\n}\n#manager .summary .summaryRow .summaryBox .amount {\n  font-weight: bold;\n  font-size: 26px;\n  text-align: center;\n}\n\n/* Pie chart */\n#manager .summary .summaryPieChart .summaryPieChartContainer .chart-container {\n  margin-top: 1rem;\n  margin-left: 0;\n}\n\n/* summary pie chart legend */\n#manager .summary .summaryPieChart .chartBody {\n  /* Make the pie chart and chart legend have equal height */\n  display: flex;\n}\n#manager .summary .summaryPieChart .chartBody .chartLegend {\n  display: flex;\n  flex-direction: column;\n  align-items: flex-start;\n  justify-content: flex-end;\n  padding-left: 6rem;\n  padding-bottom: 1rem;\n}\n#manager .summary .summaryPieChart .chartBody .chartLegend .amount {\n  font-weight: bold;\n  font-size: 24px;\n  display: block;\n  text-align: center;\n}\n\n#manager .summary .summaryPieChart .chartBody .chartLegend .title {\n  font-weight: bold;\n  font-size: 12px;\n  display: block;\n  margin-top: -1rem;\n  text-align: center;\n  padding: 5px 0 5px 0;\n}\n\n/* Make the summary pie chart work at different resolutions */\n@media (min-width: 1024px) and (max-width: 1299px) {\n  /* Summary boxes */\n  div#manager .summary .summaryRow .summaryBox {\n    /* width: 11rem; */\n    width: 18%;\n    justify-content: flex-end;\n  }\n  div#manager .summary .summaryRow .summaryBox .title {\n    /* This makes word wrapping work in ie11 */\n    width: 100%;\n  }\n  div#manager .summary .summaryRows {\n    width: 60%;\n  }\n\n  /* Summary pie chart */\n  div#manager .summary .summaryHeader {\n    text-align: center;\n  }\n  div#manager\n    .summary\n    .summaryPieChart\n    .summaryPieChartContainer\n    .chart-container {\n    margin-left: 1rem;\n  }\n  div#manager .summary .summaryPieChart .chartBody .chartLegend {\n    padding-left: 3rem;\n  }\n\n  div#manager .resultPieChartContainer .resultPieChart {\n    margin-left: 0;\n  }\n\n  /* Team summary */\n  div#manager .searchResult.teamSummary .assignmentTotals {\n    padding-left: 2.5rem;\n  }\n}\n\n/*** EMPTY PIE CHART STUFF ***/\n/* Every empty pie chart is just a big white circle */\n#manager .emptyPieChart {\n  background-color: white;\n  display: inline-block;\n  border-radius: 50%;\n}\n/* Minion empty pie charts */\n#manager .emptyPieChartContainer {\n  display: flex;\n  justify-content: center;\n}\n#manager .emptyPieChartContainer .emptyPieChart.minion {\n  margin-left: 7rem;\n  /* Make sure this thing never gets bigger or smaller */\n  min-width: 177px;\n  min-height: 177px;\n  max-width: 177px;\n  max-height: 177px;\n}\n\n@media (min-width: 992px) and (max-width: 1023px) {\n  #manager div.emptyPieChartContainer .emptyPieChart.minion {\n    margin-left: 0rem;\n  }\n}\n@media (max-width: 1299px) and (min-width: 1024px) {\n  #manager div.emptyPieChartContainer .emptyPieChart.minion {\n    margin-left: 3rem;\n  }\n}\n\n/* top of page summary */\n#manager .emptySummaryPieChartContainer {\n  margin-top: 1rem;\n  margin-left: 0;\n}\n\n/* The team lead under the search result. Also top of page summary */\n#manager .emptyPieChart.summary {\n  /* Make sure this thing never gets bigger or smaller */\n  min-width: 195px;\n  min-height: 195px;\n  max-width: 195px;\n  max-height: 195px;\n}\n\n/** The little summary expander **/\n#manager .summaryExpander {\n  display: flex;\n  justify-content: center;\n  background-color: #f5f5f5;\n  padding-top: 2rem;\n  padding-bottom: 1.5rem;\n}\n\n/** Search bar and filters **/\n#manager .filterAndSearchBar {\n  margin-top: 3rem;\n  border-bottom: 1px solid #e5e5e5;\n  padding-bottom: 1rem;\n  display: flex;\n  align-items: baseline;\n}\n\n/* Team filters to the left on search bar */\n#manager .filterAndSearchBar .filterBar {\n  padding-left: 0;\n}\n\n/* The direct team filter on search bar */\n#manager .directTeam {\n  /* Make it so we can have a flyout under the direct team link */\n  position: relative;\n  font-size: 14px;\n}\n#manager .filterAndSearchBar .filterBar .selected a {\n  font-weight: bold;\n  color: black;\n  text-decoration: none;\n  border-bottom: 2px solid black;\n}\n/* This is the little down error next to the direct team action item */\n#manager .filterAndSearchBar .filterBar .directTeam img {\n  padding-left: 1px;\n  margin-bottom: 3px;\n}\n\n/* The alternate team filter on search bar */\n#manager .filterAndSearchBar .filterBar .alternateTeam {\n  color: #aeaeae;\n  font-size: 14px;\n}\n\n/* The direct team flyout */\n#manager .directTeamFlyout {\n  position: absolute;\n  left: 10rem;\n  top: 2rem;\n  background-color: white;\n  -webkit-box-shadow: 2px 3px 2px 0px rgba(0, 0, 0, 0.23);\n  -moz-box-shadow: 2px 3px 2px 0px rgba(0, 0, 0, 0.23);\n  box-shadow: 2px 3px 2px 0px rgba(0, 0, 0, 0.23);\n  padding-left: 0;\n  z-index: 1;\n}\n#manager .directTeamFlyout li {\n  list-style-type: none;\n  width: 22rem;\n  padding-top: 0.4rem;\n  padding-bottom: 0.4rem;\n  padding-left: 1rem;\n  border-bottom: 1px solid #d5d5d5;\n  border-left: 1px solid #d5d5d5;\n  cursor: pointer;\n  /* Makes the text and checkmark on either side of the row */\n  display: flex;\n  justify-content: space-between;\n}\n/* Enhance the shadow effects in the flyout */\n#manager .directTeamFlyout li:last-child {\n  border-bottom: initial;\n}\n#manager .directTeamFlyout li:first-child {\n  border-top: 1px solid rgba(0, 0, 0, 0.1);\n}\n/* The check mark on the right of selected items in the direct team flyout */\n#manager .directTeamFlyout li .checkMark {\n  padding-right: 1.5rem;\n}\n\n/* The pipe character between the team filters on the search bar */\n#manager .filterAndSearchBar .filterBar .filter + .filter:before {\n  content: '|';\n  color: black;\n  margin-left: 1rem;\n  margin-right: 1rem;\n}\n\n/* The input box on the search bar */\n#manager .filterAndSearchBar .searchBar {\n  display: flex;\n  padding-right: 0;\n  position: relative;\n}\n#manager .filterAndSearchBar .searchBar input {\n  font-size: 14px;\n  border: 1px solid #7f7f7f;\n  padding-left: 1.5rem;\n  padding-top: 0.5rem;\n  padding-bottom: 0.5rem;\n  margin-left: 1rem;\n  flex-grow: 1;\n}\n\n/* The searchbar flyout */\n#manager .searchBarFlyout {\n  position: absolute;\n  left: 1.5rem;\n  top: 4rem;\n  background-color: white;\n  -webkit-box-shadow: 2px 3px 2px 0px rgba(0, 0, 0, 0.23);\n  -moz-box-shadow: 2px 3px 2px 0px rgba(0, 0, 0, 0.23);\n  box-shadow: 2px 3px 2px 0px rgba(0, 0, 0, 0.23);\n  padding-left: 0;\n}\n#manager .searchBarFlyout li {\n  list-style-type: none;\n  width: 13rem;\n  padding-top: 0.5rem;\n  padding-bottom: 0.5rem;\n  padding-left: 0.5rem;\n  border-bottom: 1px solid #d5d5d5;\n  border-left: 1px solid #d5d5d5;\n  display: flex;\n  cursor: pointer;\n}\n/* Make the row not interfere with the shadow */\n#manager .searchBarFlyout li:last-child {\n  border-bottom: initial;\n}\n/* Give the first row an extra shadow effect */\n#manager .searchBarFlyout li:first-child {\n  border-top: 1px solid rgba(0, 0, 0, 0.1);\n}\n#manager .searchBarFlyout li img {\n  margin-right: 0.8rem;\n}\n/* The icon in left of each row of the search bar flyout */\n#manager .searchBarFlyout li .icon {\n  width: 3rem;\n  display: flex;\n  justify-content: center;\n}\n/* The selection mark on the right of each flyout */\n#manager .searchBarFlyout li .checkMark {\n  position: absolute;\n  right: 0;\n}\n\n/* color the default text in the search bar box */\n#manager .filterAndSearchBar .searchBar input::-webkit-input-placeholder {\n  /* WebKit, Blink, Edge */\n  color: #7f7f7f;\n  font-weight: bold;\n}\n#manager .filterAndSearchBar .searchBar input:-moz-placeholder {\n  /* Mozilla Firefox 4 to 18 */\n  color: #7f7f7f;\n  opacity: 1;\n  font-weight: bold;\n}\n#manager .filterAndSearchBar .searchBar input::-moz-placeholder {\n  /* Mozilla Firefox 19+ */\n  color: #7f7f7f;\n  opacity: 1;\n  font-weight: bold;\n}\n#manager .filterAndSearchBar .searchBar input:-ms-input-placeholder {\n  /* Internet Explorer 10-11 */\n  color: #7f7f7f;\n  font-weight: bold;\n}\n\n/** Breadcrumb **/\n#manager .breadcrumb {\n  margin-bottom: 2rem;\n}\n/* spacing around separator is slightly different on\n * manager dashboard */\n#manager .breadcrumb .active span {\n  padding-left: 6px;\n}\n#manager .breadcrumb .active {\n  padding-left: 0;\n}\n\n/** Search results title **/\n#manager .resultsHeader {\n  margin: 4rem 0rem 2rem 0rem;\n}\n\n#manager .resultsHeader a {\n  float: right;\n  font-size: 12px;\n}\n\n#manager .resultsHeader h3 {\n  font-size: 24px;\n  font-weight: bold;\n  margin: 0px;\n}\n\n/** Individual search results **/\n#manager .searchResult {\n  margin-top: 1rem;\n}\n/* Search result header */\n#manager .searchResult .header {\n  background-color: #e5e5e5;\n  overflow: hidden;\n  /* height: 12rem; */\n  height: 4rem;\n}\n#manager .searchResult .memberNameAndProfileTable {\n  width: 30%;\n}\n#manager .searchResult .header .name {\n  display: inline-block;\n  font-size: 20px;\n  padding-left: 0.8rem;\n}\n#manager .searchResult .managerExpander {\n  display: inline-block;\n}\n\n/* The little sheeple icon */\n#manager .searchResult .sheepleIcon {\n  vertical-align: baseline;\n  margin-bottom: -1px;\n  padding-left: 0.2rem;\n}\n\n/* The list of folks under the manager if search result is a manager */\n#manager .searchResult .numberOfReports a,\n#manager .searchResult .numberOfReports {\n  font-size: 10px;\n}\n\n#manager .searchResult .numberOfReports {\n  top: -1rem;\n}\n\n/* The assignment / view transcript actions on the header of each search result */\n#manager .searchResult .actionItems {\n  height: 4rem; /* matches height of #manager .searchResult .header. be sure to change both if you change this */\n  display: flex;\n  align-items: flex-end;\n  padding-bottom: 0.8rem;\n  padding-right: 2rem;\n}\n\n#manager .searchResult .actionItems a {\n  font-size: 12px;\n}\n\n/* The pipe character between the action items */\n#manager .searchResult .actionItem + .actionItem:before {\n  content: '|';\n  color: black;\n  margin-left: 1rem;\n  margin-right: 1rem;\n}\n\n/* Search result profile info */\n#manager .searchResult .profileInfo {\n  background-color: #e5e5e5;\n  margin-left: 0;\n  margin-right: 0;\n  padding-left: 0.9rem;\n  padding-bottom: 1.2rem;\n}\n\n#manager .searchResult .closeProfileInfo {\n  margin-top: 0.2rem;\n}\n#manager .searchResult .closeProfileInfo a {\n  font-size: 12px;\n}\n#manager .searchResult .profileInfo .italic {\n  font-style: italic;\n}\n#manager .searchResult .profileInfo .alignRight {\n  text-align: right;\n}\n\n/* Search result body */\n#manager .searchResult .body {\n  background-color: #f5f5f5;\n  overflow: hidden;\n  padding-top: 3rem;\n  padding-bottom: 1.5rem;\n}\n\n/* Indent the pie chart for the search results */\n#manager .resultPieChartContainer .resultPieChart {\n  margin-left: 3rem;\n}\n/* Make the pie chart and legend have the same height */\n#manager .searchResult .resultPieChartContainer {\n  display: flex;\n}\n\n/* Search result pie chart legend */\n#manager .searchResult .legend {\n  display: flex;\n  justify-content: flex-end;\n  flex-direction: column;\n  align-items: flex-end;\n  padding-bottom: 3rem;\n  padding-left: 0;\n  width: 11rem;\n}\n#manager .searchResult .legendItem {\n  border: 1px solid black;\n  padding-left: 1rem;\n  padding-right: 1rem;\n  padding-bottom: 1rem;\n  padding-top: 0;\n  display: flex;\n  align-items: center;\n  flex-direction: column;\n  width: 10rem;\n  background-color: #f9f9f9;\n}\n#manager .searchResult .legendItem + .legendItem {\n  margin-top: 1.5rem;\n}\n#manager .searchResult .legendItem .amount {\n  font-size: 24px;\n  font-weight: bold;\n  margin-bottom: -0.7rem;\n}\n\n#manager .searchResult .legendItem .title {\n  font-weight: bold;\n}\n\n/* Search result assignment totals table */\n#manager .searchResult .assignmentTotals {\n  /* On the search results, not the team summary,\n     * the table is slightly indented */\n  padding-left: 5rem;\n}\n#manager .searchResult .assignmentTotals table {\n  width: 100%;\n}\n#manager .searchResult .assignmentTotals th {\n  font-weight: bold;\n  text-align: center;\n}\n#manager .searchResult .assignmentTotals tbody tr {\n  border-bottom: 1px solid #c3c2c2;\n}\n#manager .searchResult .assignmentTotals tbody td {\n  padding-top: 0.5rem;\n  padding-bottom: 0.5rem;\n}\n\n#manager .searchResult .assignmentTotals tbody td a,\n#manager .searchResult .assignmentTotals tbody td p {\n  display: inline;\n  font-size: 12px;\n}\n\n/* The data in the table (not the left most column) should be centered in the middle */\n#manager .searchResult .assignmentTotals tbody td + td {\n  text-align: center;\n}\n#manager .searchResult .assignmentTotals tfoot {\n  font-weight: bold;\n}\n#manager .searchResult .assignmentTotals tfoot td {\n  padding-top: 0.5rem;\n}\n/* The footer boxes except for the leftmost column should be centered */\n#manager .searchResult .assignmentTotals tfoot td + td {\n  text-align: center;\n}\n\n#manager .searchResult .assignmentTotals .disable-href {\n  pointer-events: none !important;\n}\n\n#manager .searchResult .assignmentTotals .enable-href {\n  pointer-events: auto !important;\n}\n\n/** Team summary overrides\n * The team summary component is just like the searchResult component except with \n * some overrides for the background color and pie chart */\n/* Background, title and team overrides */\n#manager .searchResult.teamSummary .header {\n  background-color: initial;\n  height: initial;\n}\n#manager .searchResult.teamSummary .header .name {\n  font-size: 24px;\n  font-weight: bold;\n}\n#manager .searchResult.teamSummary .body {\n  background-color: initial;\n  padding-bottom: 3rem;\n  border-bottom: 3px solid #009ce6;\n}\n/* Legend override */\n#manager .searchResult.teamSummary .legendItem {\n  width: 11rem;\n  background-color: initial;\n}\n#manager .searchResult.teamSummary .legendItem .amount {\n  font-size: 30px;\n}\n#manager .searchResult.teamSummary .legendItem .title {\n  font-size: 14px;\n}\n/* Pie chart override. Don't indent pie cahrt on manager summary */\n#manager .teamSummary .resultPieChartContainer .resultPieChart {\n  margin-left: initial;\n}\n\n/* Table override */\n#manager .searchResult.teamSummary .assignmentTotals {\n  padding-left: initial;\n}\n\n.managerCourseList .md-datepicker-input-container .md-datepicker-input,\n.managerCourseList\n  .md-datepicker-input-container\n  .md-datepicker-triangle-button,\n.managerCourseList .md-datepicker-input-container {\n  visibility: hidden;\n}\n\n.managerCourseList .edit {\n  margin-right: 15px;\n}\n\n.managerCourseList .spinner {\n  margin: 0px 125px;\n}\n\n.featureClass,\n.featureClass td {\n  text-decoration: none !important;\n  color: #979797 !important;\n}\n\n#manager .searchBar .magnifying-glass svg {\n  height: 32px;\n  width: 32px;\n}\n\n#manager .assignmentsHeader #hierarchyToggle {\n  margin-right: 5px;\n  vertical-align: text-bottom;\n}\n\n#manager .chartLegend .row {\n  background-color: white;\n  border: solid black 1px;\n  padding: 0 1rem 0 1rem;\n  min-width: 10rem;\n  margin-top: 10px;\n}\n\n#manager .overdue {\n  color: #f63f3f;\n}\n\n#manager .complete .amount {\n  color: #009ce6;\n}\n#manager .chartLegend .incomplete .amount {\n  color: #d6d6d6;\n}\n\n/* Make the team list work at different resolutions */\n@media screen and (max-width: 1200px) {\n  .searchResultRow {\n    width: 100%;\n    background-color: #e5e5e5;\n    height: 100%;\n  }\n\n  #manager .searchResult .header {\n    overflow: visible;\n  }\n\n  .barPercentComplete {\n    padding-left: 20%;\n    padding-top: 0px !important;\n  }\n\n  .actionItemLinks {\n    float: left !important;\n    padding-left: 20%;\n  }\n}\n\n#manager #overdueModal .overdueAssignmentList {\n  max-height: 55rem;\n  overflow: auto;\n}\n\n#manager #overdueModal .overdueAssignment {\n  padding: 20px;\n  border-bottom: 1px solid #e5e5e5;\n  padding-left: 40px;\n}\n\n#manager #overdueModal .title {\n  font-size: 16px;\n  font-weight: bold;\n}\n\n#manager #overdueModal .exportSpinner .spinner {\n  margin: 10px 10px 0px 0px;\n  float: right;\n}\n\n#manager .exportOverdue .spinner {\n  height: 20px;\n  margin: 0;\n  width: 100px;\n}\n\n#manager .exportOverdue .title {\n  text-decoration: underline;\n  border: none;\n  background-color: white;\n  padding-left: 20%;\n}\n\n/*  Career Path Student Summary - Start */\n\n#careerPathStudentSummary .cpStudentTile {\n  padding-top: 1.5rem;\n  padding-bottom: 1rem;\n  background-color: #f5f5f5;\n  border: 1px solid #e5e5e5;\n  display: flex;\n  flex-direction: column;\n  align-items: center;\n  margin-bottom: 20px;\n}\n\n#careerPathStudentSummary .cpStudentHeader {\n  border-bottom: 1px solid #e5e5e5;\n  width: 90%;\n}\n\n#careerPathStudentSummary .cpStudentHeader span {\n  padding-bottom: 5px;\n  padding-left: 0px;\n}\n\n#careerPathStudentSummary .cpStudentDetails {\n  padding-top: 20px;\n  width: 90%;\n}\n\n#careerPathStudentSummary .cpStudentDetails span {\n  padding-bottom: 5px;\n  padding-left: 0px;\n}\n\n#careerPathStudentSummary .resultsHeader a {\n  float: right;\n  font-size: 12px;\n}\n\n.masonry-layout {\n  column-count: 3;\n  -webkit-column-count: 3;\n}\n\n#careerPathStudentSummary .cpDetails {\n  width: 100%;\n  padding-bottom: 15px !important;\n}\n\n#careerPathStudentSummary .filterCPBar {\n  margin-left: 0px;\n  padding-bottom: 1rem;\n  margin-bottom: 2rem;\n  margin-right: 0px;\n  border-bottom: none;\n}\n\n#careerPathStudentSummary .lastItemInCPDeets {\n  padding-bottom: 5px;\n}\n\n#careerPathStudentSummary .noLeftPadding {\n  padding-left: 0px;\n}\n\n#careerPathStudentSummary .smallProfileLink {\n  font-size: 12px;\n  color: #000;\n}\n\n#careerPathStudentSummary .flexAlign {\n  display: flex;\n  flex-flow: row wrap;\n  justify-content: flex-start;\n  align-content: flex-start;\n  align-items: flex-start;\n}\n\n/*  Career Path Student Summary - End */\n"],"sourceRoot":""}]);
// Exports
export default ___CSS_LOADER_EXPORT___;
